import {mapMutations, mapActions } from 'vuex'
import FixFluidColGrid from '@/components/fix-fluid-col-grid/fix-fluid-col-grid.vue'
import Scrollbar from '@/components/scrollbar/scrollbar.vue'
import PageDropdown from '@/components/page-dropdown/page-dropdown.vue'
import AdjustmentModal from '@/components/modals/adjustment-modal/adjustment-modal.vue'
import ConfirmModal from '@/components/modals/confirm-modal/confirm-modal.vue'
import IcArrowLeft from '@/assets/svg/ic-arrow-left.svg?inline'
import IcEdit2 from '@/assets/svg/ic-edit-2.svg?inline'
import IcPrint from '@/assets/svg/ic-print.svg?inline'
import IcDownload from '@/assets/svg/ic-download.svg?inline'
import ExchangeCash from './components/exchange-cash/exchange-cash.vue'
import Encashments from './components/encashments/encashments.vue'
import Adjustments from './components/adjustments/adjustments.vue'
import FuelMoney from './components/fuel-money/fuel-money.vue'
import PrimaryInfo from './components/primary-info/primary-info.vue'
import OrderTable from './components/order-table/order-table.vue'


export default {
  name: 'ShiftReport',
  components: {
    FixFluidColGrid,
    Scrollbar,
    PageDropdown,
    AdjustmentModal,
    ConfirmModal,
    IcArrowLeft,
    IcEdit2,
    IcPrint,
    IcDownload,
    ExchangeCash,
    Encashments,
    Adjustments,
    FuelMoney,
    PrimaryInfo,
    OrderTable
  },
  data() {
    return {
      shiftReport: null,
      activeTab: 'primaryInfoTab' // primaryInfoTab || fuelAdjustmentsTab
    }
  },
  async mounted() {
    this.setData()
  },
  methods: {
    ...mapActions({
      getShiftReport: 'shiftReport/getShiftReport',
      createAdjustment: 'shiftReport/createAdjustment',
      downloadReport: 'shiftReport/downloadReport',
      printReport: 'shiftReport/printReport',
      closeShift: 'shiftReport/closeShift'
    }),
    ...mapMutations({
      setRouteManufactureId: 'manufactures/SET_ROUTE_MANUFACTURE_ID'
    }),

    async setData() {
      try {
        this.shiftReport = await this.getShiftReport(this.$route.params.id)
      } catch(e) {
        this.$router.push({
          name: 'welcome-screen'
        })
      }
    },
    onChangeEncashment() {
      this.setData()
    },
    onAdjustmentChanged() {
      this.setData()
    },
    showAdjustmentModal() {
      this.$refs['adjustment-modal'].show()
    },
    async onAddAdjustment(event) {
      await this.createAdjustment({
        admin_shift_id: this.$route.params.id,
        data: event
      })
      this.$refs['adjustment-modal'].hide()
      await this.setData()
    },
    onDownloadReport() {
      this.downloadReport(this.$route.params.id)
    },
    onPrintReport() {
      this.printReport(this.$route.params.id)
    },
    onConfirmCloseModalShow() {
      this.$refs['confirm-close-modal'].show()
    },
    async onCloseShift() {
      await this.closeShift(this.$route.params.id)
      this.setData()
    },
    onClickOrder(order) {
      this.setRouteManufactureId(this.shiftReport.manufacture.manufacture_id)
      this.$router.push({
        name: 'order-detail',
        params: {
          id: order.order_id
        }
      })
    },
    setActiveTab(tabName, open, toggle) {
      this.activeTab = tabName
      if (!open) {
        toggle()
      }
    },
    getAdminShortName(admin) {
      let result = admin.last_name
      result += ` ${admin.first_name.charAt(0).toUpperCase()}.`
      if (admin.patronymic) {
        result += ` ${admin.patronymic.charAt(0).toUpperCase()}.`
      }
      return result
    },
    getShiftDate(date) {
      return this.$moment(date).format('DD.MM.YY HH:mm:ss')
    }
  },
  watch: {
    '$route.params.id'() {
      this.setData()
    }
  }
}